import { Controller } from "@hotwired/stimulus"

// Shows a thumbnail of the model / background picked from the brand-library
// selects, so the operator can confirm who/what they chose. Fetches the image
// URL on demand from single_generations#library_asset; degrades silently when
// an asset has no image.
export default class extends Controller {
  static targets = ["modelThumb", "bgThumb"]
  static values = { url: String }

  model(e) { this.load(e.target.value, "model_id", this.hasModelThumbTarget && this.modelThumbTarget) }
  background(e) { this.load(e.target.value, "background_id", this.hasBgThumbTarget && this.bgThumbTarget) }

  async load(id, param, thumb) {
    if (!thumb) return
    if (!id) return this.clear(thumb)

    try {
      const res = await fetch(`${this.urlValue}?${param}=${encodeURIComponent(id)}`,
                              { headers: { Accept: "application/json" } })
      if (!res.ok) return this.clear(thumb)
      const { image_url } = await res.json()
      if (image_url) {
        thumb.src = image_url
        thumb.style.display = "block"
      } else {
        this.clear(thumb)
      }
    } catch {
      this.clear(thumb)
    }
  }

  clear(thumb) {
    thumb.removeAttribute("src")
    thumb.style.display = "none"
  }
}
